import { createSlice } from "@reduxjs/toolkit";

const initialProfileData = {
    "data": {},
    "languageOrientation":"ltr"
}

const profileSlice = createSlice({
    name: 'profileDetails',
    initialState: initialProfileData,
    reducers:{
        profileDetails(state,action) {
            state.data = action.payload;
        },
        setLanguageOrientation(state,action) {
            state.languageOrientation = action.payload;
        },
    }
});

export const profileAction = profileSlice.actions;

export default profileSlice.reducer;